module.exports = __webpack_public_path__ + "img/icon_distributed.a58fa091.svg";